import {
  GraphQLID,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLString
} from 'graphql'
import { dateTimeType } from './date-time-type'

export interface AttackEventNote {
  readonly id: number
  readonly uuid: string
  readonly note: string
  readonly creationTime: Date
  readonly lastModifiedTime: Date
  readonly createdByUserUuid: string
  readonly createdByUserName: string
  readonly createdByUserAvatarUrl: string
  readonly lastUpdatedByUserName: string
}

export const attackEventNoteType = new GraphQLObjectType({
  name: 'AttackEventNote',
  description: 'Discussion note for an attack event',
  fields: () => ({
    id: {
      description: 'The unique integer ID of the attack event note',
      type: new GraphQLNonNull(GraphQLID)
    },
    uuid: {
      description: 'The unique string ID of the attack event note',
      type: new GraphQLNonNull(GraphQLID)
    },
    note: {
      description: 'The attack event note value',
      type: new GraphQLNonNull(GraphQLString)
    },
    creationTime: {
      description: 'The time of creation for the attack event note',
      type: new GraphQLNonNull(dateTimeType)
    },
    lastModifiedTime: {
      description: 'The last time updated for the attack event note',
      type: new GraphQLNonNull(dateTimeType)
    },
    createdByUserUuid: {
      description:
        "The user's UUID who originally created the attack event note",
      type: new GraphQLNonNull(GraphQLString)
    },
    createdByUserName: {
      description:
        "The user's full name who originally created the attack event note",
      type: new GraphQLNonNull(GraphQLString)
    },
    createdByUserAvatarUrl: {
      description:
        "The user's avatar URL path who originally created the attack event note",
      type: new GraphQLNonNull(GraphQLString)
    },
    lastUpdatedByUserName: {
      description:
        "The user's full name who last updated the attack event note",
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})
